<template>
  <div @wheel.prevent="slide">
    <Index_index></Index_index>
    <Index_concept id="index_concept"></Index_concept>
    <Index_team id="index_team"></Index_team>
    <Index_enterprise id="index_enterprise"></Index_enterprise>
    <Index_news id="index_news"></Index_news>
    <Index_contact id="index_contact"></Index_contact>
    <index_affix/>
    <router-view/>
  </div>
</template>

<script>
import Index_index from "@/components/CN/index/Index_index";
import Index_concept from "@/components/CN/index/Index_concept";
import Index_team from "@/components/CN/index/Index_team";
import Index_enterprise from "@/components/CN/index/Index_enterprise";
import Index_news from "@/components/CN/index/Index_news";
import Index_contact from "@/components/CN/index/Index_contact";
import {reactive, onMounted} from 'vue'
import Index_affix from "@/components/CN/index/Index_affix";
import Header from '../../components/CN/Header'

export default {
  name: 'Index',
  components: {
    Index_contact,
    Index_enterprise,
    Index_team,
    Index_concept,
    Index_index,
    Index_news,
    Index_affix,
    Header,
  },

  setup() {
    let time = reactive({
      prev: Date.now(),
      now: Date.now(),
      delay: 1000,
    })
    const slide = () => {
      time.now = Date.now()
      if (time.now - time.prev > time.delay) {
        if (window.event.deltaY > 0) {
          if(window.innerHeight <= document.getElementById('index_contact').getBoundingClientRect().top){
          document.documentElement.scrollBy({
            top: window.innerHeight,
            behavior: "smooth",
          })}
        } else {
          document.documentElement.scrollBy({
            top: -window.innerHeight,
            behavior: "smooth",
          })
        }
        time.prev = Date.now()
      }
    }
    let height = window.innerHeight
    onMounted(() => {
      let concept = document.getElementById('index_concept')
      let team = document.getElementById('index_team')
      let enterprise = document.getElementById('index_enterprise')
      let news = document.getElementById('index_news')
      let contact = document.getElementById('index_contact')

      window.addEventListener('resize', () => {
        // 当top大于0小于offsettop 表明在视窗内
        console.log(window.innerHeight, height)
        if (window.innerHeight > height) {
          if (concept.getBoundingClientRect().top > 0 && concept.getBoundingClientRect().top < concept.offsetTop) {
            window.scrollTo(0, window.innerHeight)
          } else if (team.getBoundingClientRect().top > 0 && team.getBoundingClientRect().top < team.offsetTop) {
            window.scrollTo(0, window.innerHeight * 2)
          } else if (enterprise.getBoundingClientRect().top > 0 && enterprise.getBoundingClientRect().top < enterprise.offsetTop) {
            window.scrollTo(0, window.innerHeight * 3)
          } else if (news.getBoundingClientRect().top > 0 && news.getBoundingClientRect().top < news.offsetTop) {
            window.scrollTo(0, window.innerHeight * 4)
          } else if (contact.getBoundingClientRect().top > 0 && contact.getBoundingClientRect().top < contact.offsetTop) {
            window.scrollTo(0, window.innerHeight * 5)
          }
          height = window.innerHeight
        } else {
          if (concept.getBoundingClientRect().top > 0 && concept.getBoundingClientRect().top < concept.offsetTop) {
            //window.scrollTo(0, window.innerHeight)
          } else if (team.getBoundingClientRect().top > 0 && team.getBoundingClientRect().top < team.offsetTop) {
            window.scrollTo(0, window.innerHeight)
          } else if (enterprise.getBoundingClientRect().top > 0 && enterprise.getBoundingClientRect().top < enterprise.offsetTop) {
            window.scrollTo(0, window.innerHeight * 2)
          } else if (news.getBoundingClientRect().top > 0 && news.getBoundingClientRect().top < news.offsetTop) {
            window.scrollTo(0, window.innerHeight * 3)
          } else if (contact.getBoundingClientRect().top > 0 && contact.getBoundingClientRect().top < contact.offsetTop) {
            window.scrollTo(0, window.innerHeight * 4)
          }
          height = window.innerHeight
        }

      })
    })
    return {slide,}
  }
}
</script>
<style scoped>
::-webkit-scrollbar {
  display: none
}
</style>

